import { useMutation as e, useQuery as t, useQueryClient as n } from "@tanstack/react-query";
import { http as r, toListPage as i } from "@frontends/data-access-spg-api";
//#region src/lib/api/mappers.ts
function a(e) {
	return {
		id: e.id,
		externalId: e.external_id,
		name: e.name,
		platform: e.platform,
		username: e.username
	};
}
function o(e) {
	return {
		externalId: e.external_id,
		name: e.name,
		username: e.username,
		warnings: e.warnings ?? []
	};
}
function s(e) {
	return {
		platform: e.platform,
		credentials: e.credentials
	};
}
//#endregion
//#region src/lib/api/botsApi.ts
async function c(e) {
	let { data: t } = await r.get("/bots", { signal: e });
	return t.map(a);
}
async function l(e, t) {
	let { data: n } = await r.get(`/bots/platforms/${e}/credentials`, { signal: t });
	return n.required;
}
async function u(e) {
	let { data: t } = await r.post("/bots/verify", s(e));
	return o(t);
}
async function d(e) {
	let t = {
		name: e.name,
		...s(e)
	}, { data: n } = await r.post("/bots", t);
	return a(n);
}
async function f(e, t) {
	let n = { name: t };
	await r.patch(`/bots/${e}`, n);
}
async function p(e, t) {
	let n = { credentials: t };
	await r.put(`/bots/${e}/credentials`, n);
}
async function m(e) {
	await r.delete(`/bots/${e}`);
}
async function h(e, t) {
	let { data: n } = await r.get(`/bots/${encodeURIComponent(e)}/delivery`, { signal: t });
	return {
		url: n.url,
		expectedUrl: n.expected_url,
		registered: n.registered,
		pendingUpdates: n.pending_updates,
		lastErrorAt: n.last_error_at,
		lastError: n.last_error
	};
}
//#endregion
//#region src/lib/queries.ts
var g = {
	all: ["bots"],
	list: () => [...g.all, "list"],
	delivery: (e) => [
		...g.all,
		"delivery",
		e
	],
	requiredCredentials: (e) => [
		...g.all,
		"requiredCredentials",
		e
	]
};
function _(e, t) {
	let n = t.query.trim().replace(/^@/, "").toLowerCase();
	return (t.platform === "all" || e.platform === t.platform) && [
		e.name,
		e.username,
		e.externalId
	].some((e) => e.toLowerCase().includes(n));
}
function v(e, n) {
	return t({
		queryKey: g.list(),
		queryFn: ({ signal: e }) => c(e),
		select: (t) => i(t.filter((e) => _(e, n)), e, (e, t) => e[t])
	});
}
function y() {
	return t({
		queryKey: g.list(),
		queryFn: ({ signal: e }) => c(e)
	});
}
function b(e) {
	return t({
		queryKey: g.delivery(e),
		queryFn: ({ signal: t }) => h(e, t),
		staleTime: 0,
		gcTime: 0,
		retry: !1
	});
}
//#endregion
//#region src/lib/mutations.ts
function x(e) {
	return t({
		queryKey: g.requiredCredentials(e),
		queryFn: ({ signal: t }) => l(e, t),
		staleTime: Infinity
	});
}
function S() {
	return e({ mutationFn: u });
}
function C() {
	let t = n();
	return e({
		mutationFn: d,
		onSuccess: () => t.invalidateQueries({ queryKey: g.list() })
	});
}
function w() {
	let t = n();
	return e({
		mutationFn: ({ id: e, name: t }) => f(e, t),
		onSuccess: () => t.invalidateQueries({ queryKey: g.list() })
	});
}
function T() {
	return e({ mutationFn: ({ id: e, credentials: t }) => p(e, t) });
}
function E() {
	let t = n();
	return e({
		mutationFn: m,
		onSuccess: () => t.invalidateQueries({ queryKey: g.list() })
	});
}
//#endregion
export { g as botsQueryKeys, y as useAllBotsQuery, b as useBotDeliveryQuery, v as useBotsQuery, C as useCreateBotMutation, E as useDeleteBotMutation, w as useRenameBotMutation, T as useReplaceBotCredentialsMutation, x as useRequiredCredentialsQuery, S as useVerifyBotMutation };
